import { Utilities } from "shared/utilities";
import { ProcessTemplate, ProcessUsingTemplate } from "./ProcessTemplate";
import { getTableModeSelectOptions } from "shared/components/Table";

export const optionalColumnsWithLabels: Partial<Record<keyof ProcessTemplate, string>> = {
    ['id']: 'Id',
    ['guid']: 'GUID',
    ['description']: 'Description',
    ["targetFramework"]: 'Target framework',
    ['frendsVersion']: 'Frends version',
    ['tags']: 'Tags',
    ['processesUsingCurrentVersion']: 'Template used in',
    ['modified']: 'Modified',
    ['modifier']: 'Modifier',
};

export enum ProcessTemplateFilterType {
    Text = 'Text',
    Tags = 'Tags',
}

export const emptyFilter = { type: ProcessTemplateFilterType.Text, values: [] };

export const pageSizeOptions = getTableModeSelectOptions([10, 15, 25, 50, 100], [{ label: FRENDS.Localizations.Unlimited, value: Utilities.unlimitedPageSize }]);

export const visibleTemplatesListColumnsKey = 'frends_templatesList_visibleColumns';

export const getPossibleColumns = () => Object.keys(optionalColumnsWithLabels)
    .map((k: keyof ProcessTemplate) => ({ column: k, label: optionalColumnsWithLabels[k]! }));

export const getProcessListLink = (processUsingTemplate: ProcessUsingTemplate) => `Process/List/${processUsingTemplate.environment}/${processUsingTemplate.agentGroup}?highlightProcess=${processUsingTemplate.id}`;

export const getProcessEditLink = (processUsingTemplate: ProcessUsingTemplate) => `Process/Edit/${processUsingTemplate.id}`;